import { apiUrl } from '../../apiBase';
import { PACKED } from './threeDApi';

// Where a visitor reads one of a published tutorial's clip meshes, by its doc id. It carries the
// build's base like the page does, because the demo is a second app under /demo and its
// meshes are served by its own backend.
//
// Gated on the tutorial being published AND on the clips naming this run; see
// notice_public.public_tutorial_mesh, which is the whole of what makes a shared Parts DB
// safe to serve from a page with no login.
//
// IN A COLOURWAY, its id: the one shape, painted in that colourway's colours on the way out.
// PACKED, as the app's own are (see meshSrc): this is the page whose visitors wait longest.
// `split=1` says nothing to the server: it is the address of a mesh whose shape is a file of its
// own (see glbpack.split), so a browser holding the whole one from before asks again.
// AND THE COLOURWAY'S PAINT STAMP, as the app's own address carries it (see colourwayPaint): the
// browser keeps a mesh an hour, so a repaint has to be a new address or it is not seen. Set once
// from the tutorial's own data (see setPublicStamps); the server reads nothing of it.
const stamps = new Map<string, number>();
export const setPublicStamps = (subs: { variant: string; stamp?: number }[] = []) => {
  for (const s of subs) stamps.set(s.variant, s.stamp ?? 0);
};
export const publicMeshUrl = (docId: string, job: number, colourway = '') =>
  apiUrl(`/api/notice/public/tutorial/${encodeURIComponent(docId)}/mesh/${job}?pack=${PACKED}&split=1${
    colourway ? `&colourway=${encodeURIComponent(colourway)}&p=${stamps.get(colourway) ?? 0}` : ''}`);
